import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "@/features/auth/firebase";
import { Avatar } from "@mui/joy";

export function ActiveUserAvatarIcon() {
  const [user] = useAuthState(auth);
  return (
    <Avatar src={user.photoURL} size="sm" sx={{ '--Avatar-size': '24px' }} />
  );
}
